import { getChewyMobileAppVersion, isAndroidChewyMobileApp } from '../utils/nma';

/**
 * Hook to check if the user is using a compatible Android Chewy mobile app version.
 * @param headers - HTTP headers containing user agent information
 * @param minimumVersion - The minimum required version (e.g., "1.0.0")
 * @returns boolean indicating if the Android app version meets the minimum requirement
 */
export const isCompatibleAndroidVersion = (userAgent: string, minimumVersion: string): boolean => {
  if (!userAgent) return false;

  // Early return if it's an iOS app or not the Android app
  if (!isAndroidChewyMobileApp(userAgent)) return false;

  const currentVersion = getChewyMobileAppVersion(userAgent);

  if (!currentVersion) return false;

  return compareVersions(currentVersion, minimumVersion) >= 0;
};

/**
 * Compares two semantic version strings.
 * @param version1 - First version to compare
 * @param version2 - Second version to compare
 * @returns -1 if version1 < version2, 0 if equal, 1 if version1 > version2
 */
const compareVersions = (version1: string, version2: string): number => {
  const v1Parts = version1.split('.').map(Number);
  const v2Parts = version2.split('.').map(Number);

  // Pad shorter version with zeros
  const maxLength = Math.max(v1Parts.length, v2Parts.length);
  while (v1Parts.length < maxLength) v1Parts.push(0);
  while (v2Parts.length < maxLength) v2Parts.push(0);

  for (let i = 0; i < maxLength; i++) {
    if (v1Parts[i] < v2Parts[i]) return -1;
    if (v1Parts[i] > v2Parts[i]) return 1;
  }

  return 0;
};
